/**
 * `/__ui/automations` — the visual-regression and hit-test harness for M6-A2, the same trick
 * B4's board harness and M5's notifications harness use. It renders with **no session, no api
 * and no database**, so a served build can be driven with Playwright and diffed against
 * `discovery/ui-reference/automations/*.png`.
 *
 * `?screen=create|manage|runs|connections|usage` picks the tab the modal opens on.
 */
import { useMemo } from 'react';
import { AutomationsCenter, type ManageTab } from './AutomationsCenter';
import { FIXTURE_BOARD_ID, FIXTURE_BOARD_NAME, createFixtureSource } from './fixture';
import './automations.css';

export function AutomationsHarness() {
  const params = new URLSearchParams(typeof window === 'undefined' ? '' : window.location.search);
  const screen = params.get('screen') ?? 'create';
  const source = useMemo(() => createFixtureSource(), []);
  /** P-032: Manage's four sub-tabs, each openable straight from the URL. */
  const sub: ManageTab =
    screen === 'runs' ? 'runs' : screen === 'connections' ? 'connections' : screen === 'usage' ? 'usage' : 'automations';

  return (
    <div data-testid={`ui-automations-${screen}`} style={{ minHeight: '100vh' }}>
      <AutomationsCenter
        source={source}
        boardId={FIXTURE_BOARD_ID}
        boardName={FIXTURE_BOARD_NAME}
        accountName="Eli Z Group"
        initialTab={screen === 'create' ? 'create' : 'manage'}
        initialSub={sub}
        onClose={() => undefined}
      />
    </div>
  );
}
